import { Button } from "@/components/ui/button";
import { Save, X } from "lucide-react";
import { PERM_PRESETS, PERMS } from "./usuariosConstants";

// Seção reutilizável de permissões: linha de botões de preset + grid de checkboxes.
// Compartilhada entre o formulário "Novo usuário" e o dialog de edição.
// Props: target ("f" | "edit"), values, customPresets, ações, testIdPrefix.
export function PermsSection({
  target, permissions, customPresets,
  onApplyPreset, onDeleteCustomPreset, onSetAllPerms, onOpenSavePreset,
  onTogglePerm, testIdPrefix,
}) {
  const t = testIdPrefix;
  return (
    <>
      <div className="flex items-center justify-between flex-wrap gap-2 mb-2">
        <div className="text-sm font-semibold">Permissões e Nível de Acesso</div>
        <div className="flex flex-wrap items-center gap-1">
          {PERM_PRESETS.map((p) => (
            <Button key={p.k} type="button" size="sm" variant="outline"
              onClick={() => onApplyPreset(target, p)}
              data-testid={`btn-${t}preset-${p.k}`} title={p.hint}
              className="text-xs h-7 border-purple-300 text-purple-700 hover:bg-purple-50">
              {p.l}
            </Button>
          ))}
          {customPresets.map((p) => (
            <div key={p.id} className="inline-flex items-center gap-0.5 border border-sky-300 rounded overflow-hidden">
              <button type="button"
                onClick={() => onApplyPreset(target, { l: p.nome, perms: p.permissions })}
                data-testid={`btn-${t}custom-preset-${p.id}`} title={`${p.permissions.length} permissões`}
                className="text-xs h-7 px-2 text-sky-700 hover:bg-sky-50 font-medium">
                {p.nome}
              </button>
              {onDeleteCustomPreset && (
                <button type="button" onClick={() => onDeleteCustomPreset(p)}
                  data-testid={`btn-del-custom-preset-${p.id}`} title="Excluir preset"
                  className="h-7 w-6 text-sky-500 hover:bg-rose-50 hover:text-rose-600 border-l border-sky-200">
                  <X className="w-3 h-3 mx-auto" />
                </button>
              )}
            </div>
          ))}
          <span className="text-xs text-muted-foreground mx-1">·</span>
          <Button type="button" size="sm" variant="outline" onClick={() => onSetAllPerms(target, true)}
            data-testid={`btn-${t}perm-check-all`} className="text-xs h-7">Marcar todas</Button>
          <Button type="button" size="sm" variant="outline" onClick={() => onSetAllPerms(target, false)}
            data-testid={`btn-${t}perm-uncheck-all`} className="text-xs h-7">Desmarcar todas</Button>
          <Button type="button" size="sm" variant="outline" onClick={() => onOpenSavePreset(target)}
            data-testid={`btn-${t}save-preset`} className="text-xs h-7 border-emerald-300 text-emerald-700 hover:bg-emerald-50">
            <Save className="w-3 h-3 mr-1" />Salvar como preset
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {PERMS.map((p) => (
          <label key={p.k} className="flex items-center gap-2 text-sm cursor-pointer bg-orange-50/40 border border-orange-100 rounded px-2 py-1.5">
            <input type="checkbox" data-testid={`${t}perm-${p.k}`}
              checked={(permissions || []).includes(p.k)}
              onChange={() => onTogglePerm(p.k, target)}
              className="accent-orange-600" />
            {p.l}
          </label>
        ))}
      </div>
    </>
  );
}

// Grid reutilizável para vincular empresas ao usuário.
export function EmpresasSelector({ empresas, selectedIds, onToggle, target = "f", testIdPrefix = "" }) {
  const t = testIdPrefix ? `${testIdPrefix}-` : "";
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
      {empresas.map((emp) => (
        <label key={emp.id} className="flex items-center gap-2 text-sm cursor-pointer bg-orange-50/40 border border-orange-100 rounded px-2 py-1.5">
          <input type="checkbox" data-testid={`${t}emp-${emp.id}`}
            checked={(selectedIds || []).includes(emp.id)}
            onChange={() => onToggle(emp.id, target)}
            className="accent-orange-600" />
          <span className="truncate">{emp.nome}</span>
        </label>
      ))}
      {empresas.length === 0 && <div className="text-xs text-muted-foreground col-span-4">Nenhuma empresa cadastrada</div>}
    </div>
  );
}
